document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.getElementById("main-navigation-drawer");
  const menu = document.getElementById("mobile-menu");
  const toggle = document.getElementById("main-navigation-toggle");
  const closeBtn = menu?.querySelector(".main-navigation-close");
  const backdrop = menu?.querySelector(".main-navigation-backdrop");

  if (!wrapper || !menu || !toggle) return;

  const openMenu = () => {
    menu.removeAttribute("hidden");
    wrapper.setAttribute("open", "");
    toggle.setAttribute("aria-expanded", "true");

    window.setTimeout(() => {
      closeBtn?.focus();
    }, 100);
  };

  const closeMenu = () => {
    wrapper.removeAttribute("open");
    toggle.setAttribute("aria-expanded", "false");
    toggle.focus();
  };

  toggle.addEventListener("click", openMenu);
  closeBtn?.addEventListener("click", closeMenu);
  backdrop?.addEventListener("click", closeMenu);

  menu.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
    }
  });

  menu.addEventListener("transitionend", () => {
    if (!wrapper.hasAttribute("open")) {
      menu.setAttribute("hidden", "");
    }
  });
});
